import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import Facebook from './Facebook'
import LinkedIn from './LinkedIn'
import X from './X'
import { IconProps } from 'blaze-ui/icons/Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { GoHighLevel, Google, GoogleDrive, Mailchimp, Shopify, TikTokBrand, Wix, YouTubeBrand } from 'blaze-ui/icons'
import MetaBrand from 'blaze-ui/icons/20/MetaBrand'
import { WordPressBrand } from 'blaze-ui/icons/35/WordPressBrand'
import FacebookMessenger from './FacebookMessenger'
import { InstagramBrand } from 'blaze-ui/icons/35'
import { ZapierLogo } from 'almanac-ui/icons/24'

export type PlatformIconKey = ExternalIntegrationEnum | 'facebook_messenger'

const platformIconMap: Record<PlatformIconKey, React.FC<IconProps>> = {
  [ExternalIntegrationEnum.Facebook]: Facebook,
  [ExternalIntegrationEnum.Instagram]: InstagramBrand,
  [ExternalIntegrationEnum.X]: X,
  [ExternalIntegrationEnum.LinkedIn]: LinkedIn,
  [ExternalIntegrationEnum.TikTok]: TikTokBrand,
  [ExternalIntegrationEnum.YouTube]: YouTubeBrand,
  [ExternalIntegrationEnum.Mailchimp]: Mailchimp,
  [ExternalIntegrationEnum.Google]: Google,
  [ExternalIntegrationEnum.GoogleDrive]: GoogleDrive,
  [ExternalIntegrationEnum.MetaAds]: MetaBrand,
  [ExternalIntegrationEnum.GoHighLevel]: GoHighLevel,
  [ExternalIntegrationEnum.WordPress]: WordPressBrand,
  [ExternalIntegrationEnum.Wix]: Wix,
  [ExternalIntegrationEnum.Shopify]: Shopify,
  [ExternalIntegrationEnum.GoogleBusinessProfile]: Google,
  [ExternalIntegrationEnum.GoogleAds]: Google,
  [ExternalIntegrationEnum.GoogleCalendar]: Google,
  [ExternalIntegrationEnum.MicrosoftGraph]: Google,
  [ExternalIntegrationEnum.Zapier]: ZapierLogo,
  facebook_messenger: FacebookMessenger,
}

interface Props {
  platform: PlatformIconKey
  size?: number
  channel?: ChannelType
}

export const RoundedPlatformIcon = ({ platform, size = 20, channel }: Props) => {
  const Component = platformIconMap[platform]

  if (!Component) {
    if (channel) return <ChannelIcon size={size} channel={channel} />

    return null
  }

  return <Component size={size} />
}
